// Shopify-hosted videos play only while they are on screen (2026-11-03). On a phone the homepage started three 1080p
// loops at once, two of them below the fold, and they shared the connection with the first photos.
// snippets/video-sized.liquid marks the videos: data-onscreen = paused while off screen; data-onscreen-autoplay =
// starts the first time it scrolls into view. A video paused here resumes when it is back; one a slideshow paused
// stays paused, so the slideshows still decide which slide's video plays.
(() => {
  if (window.videoOnscreen || !('IntersectionObserver' in window)) return;
  window.videoOnscreen = true;

  const onScreen = new WeakMap();
  const pausedHere = new WeakSet();
  const play = (video) => {
    const started = video.play();
    if (started) started.catch(() => {});
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({ target: video, isIntersecting }) => {
      onScreen.set(video, isIntersecting);
      if (!isIntersecting) {
        if (!video.paused) {
          video.pause();
          pausedHere.add(video);
        }
      } else if (pausedHere.has(video)) {
        pausedHere.delete(video);
        play(video);
      } else if ('onscreenAutoplay' in video.dataset) {
        delete video.dataset.onscreenAutoplay; // once; after that the slideshow decides
        play(video);
      }
    });
  });

  const watch = (video) => {
    if ('onscreenWatched' in video.dataset) return;
    video.dataset.onscreenWatched = '';
    observer.observe(video);
    // A slideshow can start a video whose section is off screen (autoplay keeps changing slides): hold it until seen.
    video.addEventListener('play', () => {
      if (onScreen.get(video) === false) {
        video.pause();
        pausedHere.add(video);
      }
    });
  };

  const scan = () => document.querySelectorAll('video[data-onscreen]').forEach(watch);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
